import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { forgotCompanyPassword, clearError, clearStatus } from "../../Redux/companySlice";
import Swal from "sweetalert2";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { loading, error, resetPasswordStatus } = useSelector((state) => state.company);

  useEffect(() => {
    // Cleanup on component unmount
    return () => {
      dispatch(clearError());
      dispatch(clearStatus());
    };
  }, [dispatch]);

  useEffect(() => {
    if (resetPasswordStatus === 'emailSent') {
      Swal.fire({
        icon: 'success',
        title: 'Email Sent!',
        text: 'Please check your email for password reset instructions.',
        timer: 3000,
        showConfirmButton: false
      });
      setEmail("");
    }
  }, [resetPasswordStatus]);

  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to send reset email',
      });
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      Swal.fire({
        icon: 'warning',
        title: 'Email Required',
        text: 'Please enter your email address'
      });
      return;
    }
    await dispatch(forgotCompanyPassword(email));
  };

  return (
    <div className="flex items-center justify-center flex-col gap-4 h-[calc(100dvh-80px)] bg-gray-100 px-2 md:px-4 overflow-hidden">
      {/* <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-orange-500">Infuber</h1> */}
      <div className="bg-white p-2 md:p-4 rounded-xl shadow-lg w-full max-w-sm sm:max-w-md lg:max-w-xl">
        <div className="text-center mb-6">
          <h5 className="mt-2 text-gray-700 font-bold text-xs md:text-sm">🔐 Forgot Password?</h5>
          <p className="text-xs md:text-sm text-gray-500">We'll send you an email to reset your password.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-xs md:text-sm font-medium text-gray-700">Email</label>
              <div className="relative flex items-center">
                <Mail className="absolute left-3 w-4 h-4 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full pl-10 p-2 border rounded-lg text-xs md:text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition text-sm sm:text-base font-medium ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        </form>

        <p className="text-xs md:text-sm text-gray-500 text-center mt-4 font-medium">
          <Link to="/company/login" className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:border-gray-400 transition-colors duration-200">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
